module.exports = __webpack_public_path__ + "static/media/dashboard-icon-vai.94ef252e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dashboard-icon-vai.svg
// module id = 742
// module chunks = 0